import { render } from "./ServiceInvoiceListView.vue?vue&type=template&id=72de64f1"
import script from "./ServiceInvoiceListView.vue?vue&type=script&lang=js"
export * from "./ServiceInvoiceListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__